const TreeFilter = () => import("@/components/common/tree/Filter");
export default {
  components: { TreeFilter },
  props: {
    // 源数据
    treeData: {
      type: Array,
      default: function() {
        return [];
      },
    },

    // 树节点是否默认展开
    treeExpandAll: {
      type: Boolean,
      default: true,
    },

    // 树节点唯一标识
    treeNodeKey: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },

      selectItem: {},
    };
  },

  methods: {
    // 添加新增按钮
    // handleAdd(data) {
    // 	this.$emit('addItem', data);
    // },

    // 点击编辑标记目录图标。
    handleEdit(data) {
      this.selectItem = data;
      this.$emit("editItem", JSON.parse(JSON.stringify(data)));
    },
    // 点击删除标记目录图标。
    handleDelete(data) {
      this.$emit("deleteItem", data);
    },

    // 点击编辑标记图标。
    surveilEdit(data) {
      console.log(data);
      this.$refs.videoSTree.setCurrentKey(data.id);
      this.selectItem = data;
      let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
      this.$GLOBAL.markDrawGraphicLayerObj = layer;
      this.$emit("editSurveil", JSON.parse(JSON.stringify(data)));

      // console.log(1111111111111);
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(JSON.parse(JSON.stringify(this.$GLOBAL.markDrawGraphicLayer)));
      // console.log(layer);
    },
    // 点击删除标记图标。
    surveilDelete(data) {
      let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
      this.$GLOBAL.markDrawGraphicLayerObj = layer;
      this.$emit("deleteSurveil", data);
    },

    // ============== 组件内事件 结束=============

    // ============== 父组件回调事件 开始=============

    // 添加新记录，树形列表回显
    treeAddItem(data) {
      this.$refs.videoSTree.append(data, data.parentId);
    },

    // 删除节点
    treeDeleteItem(val) {
      this.$refs.videoSTree.remove(val);
    },

    // 修改记录，树形列表回显
    treeEditItem(val) {
      //console.log(this.$parent.getData);
      // console.log(JSON.parse(JSON.stringify(val)));
      // console.log(22222222222);
      Object.assign(this.selectItem, val);
      this.selectItem = {};
      this.$emit("refreshTreeData"); //刷新树
      //this.$parent.initTreeData();
    },
    nodeClick(data) {
      //alert(0)
      //还有一层el-scrollbar组件在里面。
      this.$parent.surveilNodeClick(data);
    },
    playVideo(data) {
      this.$emit("playSurveilVideo", data.bimVideoCamera.url); //刷新树
    },
    // ============== 父组件回调事件 结束=============
    filterNode(value, data, node) {
      if (!value) {
        //如果数据为空，则返回true,显示所有的数据项
        node.expanded = true;
        return true;
      } // 查询列表是否有匹配数据，将值小写，匹配英文数据
      let val = value.toLowerCase();
      return this.chooseNode(val, data, node); // 调用过滤二层方法
    },
    chooseNode(value, data, node) {
      if (data.text.toLowerCase().indexOf(value) !== -1) {
        return true;
      }
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        // 如果匹配到直接返回，此处name值是中文字符，enName是英文字符。判断匹配中英文过滤
        if (parentData.data.text.toLowerCase().indexOf(value) !== -1) {
          return true;
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    },
  },
  watch: {},
};
